import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from 'vue';
  import { ColletionBinStore } from '@/stores';
  import { useRouter } from 'vue-router';
  import SelfRecyclingPage from '@/components/self-recycling-page.vue';
  import { IUserRequest } from '@/types/user-request';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const collectionBinStore = inject('collectionBinStore') as ColletionBinStore;

  const router = useRouter();
  function handleSubmited(data: IUserRequest) {
    router.replace({ name: 'offline_collections.bin.request_reward', params: { userRequestId: data.id, remainingNumberOfBarcodes: data.remaining_number_of_barcodes } });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelfRecyclingPage, {
    "collection-bin-store": _unref(collectionBinStore),
    onSubmited: handleSubmited
  }, null, 8, ["collection-bin-store"]))
}
}

})